import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const savedLanguage = localStorage.getItem('app_language');
const browserLanguage = navigator.language.startsWith('pt') ? 'pt-BR' : 'en';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            'pt-BR': {
                translation: require('./locales/pt-BR.json'),
            },
            en: {
                translation: require('./locales/en.json'),
            },
        },
        lng: savedLanguage ?? browserLanguage, // 🔥 LÊ UMA VEZ SÓ
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
